import { LoginForm } from "@/components/login-form";
import { useAuthStore } from "@/stores/auth-store";
import { STRINGS } from "@/constants/strings";

interface LoginPageProps {
  onForgotPassword: () => void;
}

export default function LoginPage({ onForgotPassword }: LoginPageProps) {
  const tenantName = useAuthStore((s) => s.tenantName);

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
      <div className="w-full max-w-sm">
        <LoginForm onForgotPassword={onForgotPassword} />
      </div>
      <p className="text-xs text-muted-foreground">
        {tenantName ?? STRINGS.app.name}
      </p>
    </div>
  );
}
